// automatically generated by the FlatBuffers compiler, do not modify
/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */
import * as flatbuffers from 'flatbuffers'

import {Id} from './id.js'

export class ReplyAnchor {
  bb: flatbuffers.ByteBuffer | null = null
  bb_pos = 0
  __init(i: number, bb: flatbuffers.ByteBuffer): ReplyAnchor {
    this.bb_pos = i
    this.bb = bb
    return this
  }

  root(obj?: Id): Id | null {
    return (obj || new Id()).__init(this.bb_pos, this.bb!)
  }

  static sizeOf(): number {
    return 8
  }

  static createReplyAnchor(
    builder: flatbuffers.Builder,
    root_site: number,
    root_timestamp: number
  ): flatbuffers.Offset {
    builder.prep(4, 8)
    builder.prep(4, 8)
    builder.writeInt32(root_timestamp)
    builder.pad(2)
    builder.writeInt16(root_site)
    return builder.offset()
  }
}
